import React, { useEffect, useState } from 'react';
import ReactHighcharts from 'react-highcharts';
import { useDispatch } from 'react-redux';
import actions from '../../../redux/actions';

import reportsLoader from '../../../public/icons/loader.png';

const LeadingPrograms = () => {
    const { dashboardCourseGraph } = actions;
    const dispatch = useDispatch()
    const [resp, setResp] = useState()
    const [loading, setLoading] = useState()

    const [config, setConfig] = useState(null)
    const [percentage, setPercentage] = useState('75')

    const fetchData = async () => {
        setLoading(true)

        try {
            const response = await dispatch(dashboardCourseGraph(percentage))
            setResp(response.data)

            setConfig({
                chart: {
                    type: 'column'
                },
                title: {
                    text: '',
                    align: 'left'
                },
                xAxis: {
                    categories: response.data?.graph_data.map((data) => data?.label)
                },
                yAxis: {
                    allowDecimals: false,
                    min: 0,
                    title: {
                        text: ''
                    }
                },
                tooltip: {
                    pointFormat: '<b>{point.category}</b><br/>{series.name}: {point.y}'
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        borderRadius: 5, // Set the border radius for rounded corners
                    }
                },
                series: [
                    {
                        name: 'Users Enrolled',
                        data: response.data?.graph_data.map((data) => data?.user_count),
                        color: '#6FCF97'

                    },
                    {
                        name: 'Attendance Percentage',
                        data: response.data?.graph_data.map((data) => data?.user_count_attendance),
                        color: '#394CFF'



                    },


                ]
            })
        }
        catch (e) {

        }
        finally {
            setLoading(false)
        }


    }

    useEffect(() => {
        fetchData()
    }, [percentage])

    const handleChange = (e) => {
        setPercentage(`${e.target.value}`)
    }


    return (
        <div className='userLogins'>
            <div className="flexCard">
                <h3 className='graphTitle'>Leading Programmes</h3>
                {/* <span>View Report</span> */}
                <select onChange={handleChange}>
                    <option value="75">75% Attendence Percentage</option>
                    <option value="80">80% Attendence Percentage</option>
                    <option value="90">90% Attendence Percentage</option>

                </select>
            </div>

            <hr />

            <div className="graph" style={{ flexGrow: 1 }}>
                <div className="left">
                    <h2 className='graphCount'>{resp?.total_course ?? 0}</h2>
                    <span className='graphCountName'>Programmes</span>
                    <h2 className='graphCount'>{resp?.total_course_user ?? 0}</h2>
                    <span className='graphCountName'>Enrolled users</span>
                </div>
                <div className="right">
                    {
                        config && !loading ? <ReactHighcharts config={config} /> : <div className="loader">
                            <img style={{ width: '60px' }} src={reportsLoader} />
                        </div>
                    }

                </div>
            </div>
        </div>
    )
}

export default LeadingPrograms